var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"divider"}),_vm._v(" "),_c('i',{staticClass:"fa fa-copyright fa-1x",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"team-name"},[_vm._v("SCAN-ATAC GPU Simulator")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af55a40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/footerNew.vue
// module id = null
// module chunks = 